import getLocalString from "constants/Localization";
import {
  CustomGetProposalDocument,
  Proposal,
  useCustomCopyProposalProductToStageMutation,
  CustomCopyProposalProductToStageMutation,
  CustomCopyProposalProductToStageMutationVariables,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCopyProposalProductToStage({
  proposalId,
}: {
  proposalId: Proposal["id"];
}) {
  const [mutation, { loading, error, data }] = useCustomCopyProposalProductToStageMutation({
    refetchQueries: [
      {
        query: CustomGetProposalDocument,
        variables: { id: proposalId },
      },
    ],
  });

  const [copyProposalProductToStage, context] = useBitumioMutation<
    CustomCopyProposalProductToStageMutationVariables,
    CustomCopyProposalProductToStageMutation,
    "copyProposalProductToStage"
  >(
    {
      mutation,
      loading,
      error,
      data,
      key: "copyProposalProductToStage",
    },
    {
      successMessage: getLocalString("proposals.copy-proposal-product-to-stage-success"),
      failureMessage: getLocalString("proposals.copy-proposal-product-to-stage-failure"),
    }
  );

  return [copyProposalProductToStage, context] as const;
}
